import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "company-editing-drawer__close-trigger" }
const _hoisted_2 = { class: "report-revision-drawer__sections" }
const _hoisted_3 = { class: "report-revision-drawer__section" }
const _hoisted_4 = { class: "report-revision-drawer__section-content" }
const _hoisted_5 = { class: "report-revision-drawer__section" }
const _hoisted_6 = { class: "report-revision-drawer__section-content" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]

import { computed, ref, watch } from 'vue';
import { CloseOutlined } from '@ant-design/icons-vue';
import { showStcWarningNotification } from '@/js/components/stc-notification';
import {
  Col as ACol,
  Drawer as ADrawer,
  Form as AForm,
  FormItem as AFormItem,
  Row as ARow,
  Space as ASpace,
  Textarea as ATextarea,
} from 'ant-design-vue';
import FormFileUpload, { type FileUploadItem } from '@/js/components/form/form-file-upload.vue';

const COMMENT_MAX_LENGTH = 512;


export default /*@__PURE__*/_defineComponent({
  __name: 'ReportRevisionDrawer',
  props: {
    open: { type: Boolean },
    saving: { type: Boolean }
  },
  emits: ["update:open", "submit"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const comment = ref('');
const fileItems = ref<FileUploadItem[]>([]);
const fileUploadRef = ref<InstanceType<typeof FormFileUpload> | null>(null);

const canSubmit = computed(() => comment.value.trim().length > 0);

watch(
  () => props.open,
  (isOpen) => {
    if (isOpen) {
      return;
    }

    comment.value = '';
    fileItems.value = [];
    fileUploadRef.value?.reset();
  },
);

function handleSubmit(): void {
  if (!canSubmit.value || props.saving) {
    return;
  }

  const readyFiles = fileUploadRef.value?.getReadyFiles() ?? [];
  const hasUploadingFiles = fileItems.value.some((item) => item.status === 'uploading');

  if (hasUploadingFiles) {
    showStcWarningNotification('Дождитесь окончания загрузки файлов');
    return;
  }

  emit('submit', {
    comment: comment.value.trim(),
    files: readyFiles,
  });
}

return (_ctx: any,_cache: any) => {
  const _component_a_divider = _resolveComponent("a-divider")!

  return (_openBlock(), _createBlock(_unref(ADrawer), {
    width: 800,
    open: __props.open,
    class: "company-editing-drawer report-revision-drawer",
    "body-style": { paddingBottom: '24px' },
    "header-style": { padding: '32px 40px 32px 40px' },
    "footer-style": { textAlign: 'left', padding: '20px 40px 40px 40px' },
    "destroy-on-close": "",
    onClose: _cache[3] || (_cache[3] = ($event: any) => (emit('update:open', false)))
  }, {
    title: _withCtx(() => [...(_cache[4] || (_cache[4] = [
      _createElementVNode("div", { class: "report-revision-drawer__header" }, [
        _createElementVNode("h3", { class: "report-revision-drawer__title" }, "Вернуть на доработку"),
        _createElementVNode("p", { class: "report-revision-drawer__subtitle" }, "Укажите причину возврата отчета на доработку")
      ], -1)
    ]))]),
    closeIcon: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_unref(CloseOutlined))
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(ARow), {
        align: "middle",
        justify: "end",
        class: "company-editing-drawer__toolbar"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ACol), null, {
            default: _withCtx(() => [
              _createVNode(_unref(ASpace), null, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-secondary btn-medium",
                    disabled: __props.saving,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('update:open', false)))
                  }, " Отмена ", 8, _hoisted_7),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-primary btn-medium",
                    disabled: __props.saving || !canSubmit.value,
                    onClick: handleSubmit
                  }, _toDisplayString(__props.saving ? 'Отправка...' : 'Отправить'), 9, _hoisted_8)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("section", _hoisted_3, [
          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "report-revision-drawer__section-label" }, "1. Причина", -1)),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(AForm), {
              layout: "vertical",
              class: "report-revision-drawer__form"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(AFormItem), {
                  label: "Комментарий",
                  class: "stc-ant-field-skin report-revision-drawer__field",
                  required: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(ATextarea), {
                      value: comment.value,
                      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((comment).value = $event)),
                      placeholder: "Причина возврата отчета",
                      maxlength: COMMENT_MAX_LENGTH,
                      "auto-size": { minRows: 6, maxRows: 10 },
                      "show-count": ""
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode(_component_a_divider, { class: "report-revision-drawer__divider" }),
        _createElementVNode("section", _hoisted_5, [
          _cache[6] || (_cache[6] = _createElementVNode("span", { class: "report-revision-drawer__section-label" }, "2. Документы", -1)),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(FormFileUpload, {
              ref_key: "fileUploadRef",
              ref: fileUploadRef,
              modelValue: fileItems.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fileItems).value = $event))
            }, null, 8, ["modelValue"])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})